import React from "react";
import * as Option from "fp-ts/lib/Option";
import { HydrationHelper } from "core/utils";
import { RealAuthManager } from "./AuthManager/RealAuthManager";
export var block = function (data) {
    var hydrationComplete = HydrationHelper.useComplete();
    if (data.votingId === null || !hydrationComplete) {
        return Option.none;
    }
    // const {
    //   Provider: AmplifyProvider,
    //   mutator,
    //   subscriber,
    //   connectionManager,
    // } = AmplifyHelper.configure({
    //   awsRegion: GLOBALS.votingAwsRegion,
    //   apiUrl: GLOBALS.votingApiUrl,
    //   apiKey: GLOBALS.votingApiKey,
    // });
    var authManager = new RealAuthManager();
    return Option.some({
        key: "voting",
        View: function () { return (
        // <AmplifyProvider>
        //   <Dependencies.Provider
        //     dependencies={{ authManager, subscriber, mutator, connectionManager }}
        //   >
        //     <Provider
        //       onLoginClick={async () => {
        //         window.location.href = "/login";
        //       }}
        //     />
        //   </Dependencies.Provider>
        // </AmplifyProvider>
        React.createElement(React.Fragment, null)); },
    });
};
